//src/components/cropper/Sliders.jsx
import React from 'react';
import { useImageCropContext } from './pic-image-crop-provider';
import { Slider, Space } from 'antd';
import { GraySpan } from 'components/Custom/spans';
import { useTranslation } from 'react-i18next';

export const ZoomSlider = ({ className }) => {
  const { zoom, setZoom } = useImageCropContext();

  const { t } = useTranslation();

  return (
    <Space style={{ width: '50%' }}>
      <GraySpan id="profile-crop-zoom-label">{t('common.zoom')}</GraySpan>
      <Slider
        value={zoom}
        min={1}
        max={3}
        step={0.1}
        style={{ width: '120px' }}
        aria-labelledby="profile-crop-zoom-label"
        onChange={(zoom) => setZoom(zoom)}
      />
    </Space>
  );
};

export const RotationSlider = ({ className }) => {
  const { rotation, setRotation } = useImageCropContext();

  const { t } = useTranslation();

  return (
    <Space style={{ width: '50%' }}>
      <GraySpan id="profile-crop-rotation-label">{t('common.rotation')}</GraySpan>
      <Slider
        value={rotation}
        min={0}
        max={360}
        step={5}
        style={{ width: '120px' }}
        aria-labelledby="profile-crop-rotation-label"
        onChange={(rotation) => setRotation(rotation)}
      />
    </Space>
  );
};
